<template>
  <dialog :open="isOpen" class="default-dialog">
    <div class="dialog-content">
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">{{ title }}</h2>
          <p v-if="versionLabel" class="dialog-meta">{{ versionLabel }}</p>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body scroll">
        <div v-if="loading">Carregando...</div>
        <div v-else-if="error" class="error">{{ error }}</div>
        <div v-else class="legal-html" v-html="html"></div>
      </main>
    </div>
  </dialog>
</template>

<script>
import LegalHttp from "@/http/LegalHttp.js";

export default {
  name: "Terms",
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      title: "Termos de Uso",
      loading: false,
      error: "",
      html: "",
      version: "",
      publishedAt: "",
    };
  },
  computed: {
    versionLabel() {
      if (!this.version) return "";
      return `Versão ${this.version}${this.publishedAt ? " · " + this.publishedAt : ""}`;
    },
  },
  watch: {
    isOpen(v) {
      if (v) this.load();
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async load() {
      this.loading = true;
      this.error = "";
      try {
        const res = await LegalHttp.getPublicByType("terms");
        this.html = res.data?.content_html || "";
        this.version = res.data?.version || "";
        this.publishedAt = res.data?.published_at || "";
        if (res.data?.title) this.title = res.data.title;
      } catch (e) {
        this.error = "Não foi possível carregar os Termos de Uso.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
}
dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}
dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}
.dialog-content {
  width: 740px;
  max-width: 100%;
  background: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 2;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}
.dialog-title {
  font-size: 22px;
  margin: 0;
  color: #111;
}
.dialog-meta {
  margin: 4px 0 0;
  font-size: 12px;
  color: #7c3aed;
  font-weight: 700;
}
.close-icon-button {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
}
.dialog-body {
  max-height: 60vh;
  overflow: auto;
}
.legal-html {
  font-size: 14px;
  line-height: 1.5;
  color: #334155;
}
.legal-html :deep(h3) {
  margin: 14px 0 6px;
  font-size: 15px;
  color: #1a1230;
}
.error {
  color: #b91c1c;
}
</style>
